import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LedgersRepository from "../../Repository/LedgersRepository";

const initialState = {
  loading: false,
  error: "",
  ledgersNames: [],
};
export const getLedgersNames = createAsyncThunk("ln/fetchln", () => {
  return LedgersRepository.ledgerModel({
    request: {
      method: "getLedgersByCompany",
      data: {
        company_code: localStorage.getItem("companyCode"),
        returnNames: true,
      },
    },
  })
    .then(({ data }) => data.response.data.ledgers)
    .catch((err) => console.log(err));
});

export const getLedgersNamesRegions = createAsyncThunk("ln/fetchln", () => {
    const regionNames =  JSON.parse(localStorage.getItem("ledgerRegions"))
  return LedgersRepository.ledgerModel({
    request: {
      method: "getLedgersByCompany",
      data: {
        company_code: localStorage.getItem("companyCode"),
        // returnNames: true,
        ledgerRegions:regionNames,
      },
    },
  })
    .then(({ data }) => data.response.data.ledgers)
    .catch((err) => console.log(err));
});
export const getLedgersNamesPayment = createAsyncThunk("ln/fetchln", () => {
  return LedgersRepository.ledgerModel({
    request: {
      method: "getLedgersByCompany",
      data: {
        company_code: localStorage.getItem("companyCode"),
        next_page_token: ""
      },
    },
  })
    .then(({ data }) => data.response.data.ledgers)
    .catch((err) => console.log(err));
});
export const ledgersNamesSlice = createSlice({
  name: "ledgersNames",
  initialState,

  reducers: {
    clearLedgersNames: (state) => {
      state.ledgersNames = [];
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getLedgersNames.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLedgersNames.fulfilled, (state, action) => {
      state.loading = false;
      state.ledgersNames = action.payload;
      state.error = "";
    });

    builder.addCase(getLedgersNames.rejected, (state, action) => {
      state.loading = false;
      state.ledgersNames = [];
      state.error = action.error.message;
    });
  },
});

export const { clearLedgersNames } = ledgersNamesSlice.actions;
export default ledgersNamesSlice.reducer;
